export default "__VITE_ASSET__VWF4Y0Fz__"